import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
// import { useHistory } from "react-router";
import { Redirect, useHistory } from "react-router-dom";
import { AuthServices } from "../services/AuthService";
import { useLoadingMessage } from "../components/useLoadingMessage";
import AuthVerify from "../common/Auth.verify";
import store from "../store";

const defaultState = {
  checkedSessionExp: () => {},
  user: null,
  isLoading: false,
  login: async (model) => {},
  logout: () => {},
  refresh: () => {},
};

export const AuthContext = React.createContext(defaultState);

export const AuthConsumer = AuthContext.Consumer;

export const AuthProvider = ({ children }) => {
  const { message, updateLoader } = useLoadingMessage();
  const alert = useAlert();
  const history = useHistory();
  const [user, setUser] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [ready, setReady] = React.useState(false);
  const refresh = async () => {
    setIsLoading(true);
    try {
      const response = await AuthServices.getAuth();
      setReady(true);

      if (response == undefined) {
        setUser(null);
        setIsLoading(false);
      }
      setUser(response.data);

      // if (redirectIfValid) {
      //   history.replace(redirectIfValid)
      // }
    } catch (err) {
      setUser(null);
    }

    // if (!!localStorage.getItem("sessionExp") === true) {
    //   checkedSessionExp();
    //   localStorage.removeItem("sessionExp");
    // }

    setIsLoading(false);
    setReady(true);
  };

  const checkedSessionExp = () => {
    setIsLoading(true);
    alert.error("Your session has expired.....Please login again");
    AuthServices.logOut();
    localStorage.removeItem("token");
    history.push("/");
    setIsLoading(false);
  };

  useEffect(() => {
    refresh();
  }, [localStorage.token]);

  const login = async (model, redirectTo) => {
    const response = await AuthServices.login(model);
    if (response.data.status === 200) {
      if (response.data.data.user.is_first_login === 1) {
        const email = response.data.data.user.email;
        console.log("You have to change your password before logging in");
        history.push("/first-time-login", { email });
        localStorage.setItem("token", response.data.data.token);
        // setUser(response.data.data.user);
      } else {
        localStorage.setItem("token", response.data.data.token);
        setUser(response.data.data.user);
        history.push("/dashboard/index");
        alert.success("User logged in successfully");
      }
    } else {
      // console.log(response.data.error);
      alert.error("Invalid Credential");
    }
  };

  const logout = async () => {
    setIsLoading(true);
    AuthServices.logOut();
    setUser(null);
    alert.success("User logged out successfully");
    localStorage.removeItem("token");
    history.push("/");
    setIsLoading(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        login,
        logout,
        refresh,
        ready,
        checkedSessionExp,
      }}
    >
      {/* <AuthVerify logout={checkedSessionExp} /> */}
      {children}
    </AuthContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/Context/AuthContext.js